const UpsertDevice = [
    'antenna_level',
    'api_url',
    'apk_version',
    'auth_key',
    'background_colour',
    'cec_enabled',
    'chain_id',
    'device_owner',
    'device_type',
    'disable_zoom',
    'display_group',
    'file_auth',
    'file_url',
    'filter_level',
    '4k_resolution',
    'id',
    'installed_at',
    'ip',
    'layer_enabled',
    'layer_extra',
    'mac',
    'manufacturer',
    'migrated_at',
    'model',
    'ntp_url',
    'screen_rotation',
    'selected_channel',
    'selected_type',
    'sku',
    'socket_url',
    'store_code',
    'store_location',
    'store_sync',
    'sync_delay',
    'sync_offset',
    'sync_timeout',
    'sync_url',
    'usb_serial',
    'volume',
    'wifi_settings',
    'working_close',
    'working_open',
]

// eslint-disable-next-line import/prefer-default-export
export { UpsertDevice }
